import Component from '../core/Component'
import Highcharts from 'highcharts'

import dataAktiva from '../data/charts/aktiva'
import dataObrat from '../data/charts/obrat'
import dataKapital from '../data/charts/kapital'
import dataVykon from '../data/charts/vykon'

export default class Chart extends Component {

    constructor($element) {
        super($element)
        this.source = this.$element.data('source')
        if (this.source == null) {
            console.warn('Data attr. with name of source is required.')
        }

        this.data = {
            dataAktiva,
            dataObrat,
            dataKapital,
            dataVykon
        }
    }

    prepare() {
        this.settings = {
            ...this.settings,
            ...this.data[this.source]
        }

        this.$element.on('hasDisplayed', () => {
            this.chart = Highcharts.chart(this.element, this.settings)
        })
    }

    setData(data) {
        this.settings = {
            ...this.settings,
            ...data
        }
        this.chart.destroy();
        this.chart = Highcharts.chart(this.element, this.settings)
    }

    settings = {
        chart: {
            zoomType: 'xy'
        },
        title: {
            text: ''
        },
        exporting: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            series: {
                connectNulls: true,
                pointStart: 2010
            },
            line: {
                color: '#31b3e8'
            }
        },
        legend: {
            enabled: false
        },
        zoom: {
            enabled: false
        },
        xAxis: {
            type: 'category',
            title: {
                text: ''
            },
            categories: "",
            crosshair: true,
            labels: {
                style: {
                    fontSize: '15px'
                },
                rotation: -45,
                step: 1
            }
        },
        yAxis: [{
            title: {
                text: ''
            },
            categories: "",
            labels: {
                format: '{value}',
                style: {
                    color: '#b0b6c3',
                    fontSize: '15px'
                }
            },
            opposite: false
        }],
        tooltip: {
            enabled: true
        },
    }

}



// WEBPACK FOOTER //
// ./components/Chart.js